var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "py-4" },
    [
      _vm.promotion
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
              _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "text-primary-link",
                      attrs: { to: "/promotions" }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.promotion.title")) +
                          "\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("i", { staticClass: "fal fa-angle-right" }),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.promotion.detail")) +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isExpired(_vm.promotion)
                ? _c("section", [
                    _c("div", { staticClass: "py-3" }, [
                      _c("img", {
                        staticClass: "img-fluid rounded",
                        attrs: { src: _vm.promotion.image_xl }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "promotion-title pb-2" }, [
                      _vm._v(_vm._s(_vm.promotion.name))
                    ]),
                    _vm._v(" "),
                    _vm.promotion.promo_code
                      ? _c("div", [
                          _c("div", { staticClass: "text-remark pb-2" }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.promotion.promo_code")) +
                                ":"
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "border border-info rounded text-center text-info p-2 promotion-title position-relative"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.promotion.promo_code.code) +
                                  "\n            "
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "position-absolute",
                                  staticStyle: { top: "10px", right: "8px" }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      directives: [
                                        {
                                          name: "clipboard",
                                          rawName: "v-clipboard:copy",
                                          value: _vm.promotion.promo_code.code,
                                          expression:
                                            "promotion.promo_code.code",
                                          arg: "copy"
                                        }
                                      ],
                                      staticClass: "text-info",
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.savePromoCode(
                                            _vm.promotion.promo_code
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fal fa-copy fa-lg"
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center text-remark pt-3" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.$t("message.promotion.duration")) +
                                  " " +
                                  _vm._s(
                                    _vm._f("prettyOnlyDate")(
                                      _vm.promotion.end_date
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.$t("message.promotion.only")) +
                                  "\n          "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "pt-4",
                        staticStyle: { "white-space": "break-spaces" }
                      },
                      [_vm._v(_vm._s(_vm.promotion.detail))]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "pt-4" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-block btn-lg",
                          on: {
                            click: function($event) {
                              return _vm.showSelectServiceModal()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("message.menu.book_cleaner")) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ])
                : _c("section", { staticClass: "pt-5 text-center" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.$t("message.promotion.expired_promotion"))
                      )
                    ])
                  ])
            ])
          ])
        : _c("div", [_c("loader")], 1),
      _vm._v(" "),
      _c("select-service-modal", {
        ref: "selectServiceModal",
        attrs: { promotion: _vm.promotion }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ae25968", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ae25968","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/promotion/PromotionDetail.vue
// module id = 2073
// module chunks = 0